import React from "react";
import Flag, { FLAG_ICONS_MAPPING } from "./Flag";

interface RequestFlagIconProps {
  flag: Flag;
}

const RequestFlagIcon: React.FC<RequestFlagIconProps> = (props) => {
  const { flag } = props;

  return FLAG_ICONS_MAPPING[flag];
};

export default RequestFlagIcon;
